import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const indicatorSeparatorStyle = {
  alignSelf: 'stretch',
  backgroundColor: 'transparent',
  marginBottom: 8,
  marginTop: 8,
  width: 0,
};

const IndicatorSeparator = ({ innerProps }) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />;
};

const Mahalla = (props) => {
  const {
    input,
    meta: { touched, error },
    options,
    writeMahalla,
  } = props;
  const { onChange, value } = input;

  const newMakhallas = [
    {
      value: '',
      label: '',
    },
    ...options.map((mahalla) => ({ value: mahalla.id, label: mahalla.title })),
    {
      value: '',
      label: <FormattedMessage {...messages.feedback_label} />,
      modal: 'mahalla',
      color: 'red',
    },
  ];
  const [borderColor, setBorderColor] = useState('#ccc');

  useEffect(() => {
    if (value.modal === 'mahalla') {
      writeMahalla();
    }
  }, [value]);

  useEffect(() => {
    if (touched && error) {
      setBorderColor('red');
    } else {
      setBorderColor('#ccc');
    }
  }, [touched, error]);

  const customStyles = {
    option: (option, state) => {
      let color;
      if (state.data.value === '') {
        color = state.data.color;
      }
      return { ...option, color };
    },
    control: (controlStyles, { theme }) => {
      theme.colors.primary = 'none';
      return {
        // none of react-select's styles are passed to <Control />
        ...controlStyles,
        backgroundColor: 'transparent',
        border: 'none',
        borderBottom: `${borderColor === '#ccc' ? '1px' : '2px'} solid ${borderColor}`,
        borderRadius: '0',
      };
    },
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';
      let color;
      if (state.data.value === '') {
        color = state.data.color;
      }

      return { ...provided, opacity, transition, color };
    },
  };

  return (
    <React.Fragment>
      <div className="col-md-9">
        <div className="md-form">
          <Select
            {...input}
            value={newMakhallas.find((item) => String(item.value) === String(value))}
            onChange={onChange}
            onBlur={(event) => event.preventDefault()}
            options={newMakhallas}
            styles={customStyles}
            placeholder={<FormattedMessage {...messages.choose_mahalla} />}
            components={{ IndicatorSeparator }}
            noOptionsMessage={() => (
              <div style={{ color: '#808080' }} className="mt-1">
                <span onClick={writeMahalla} style={{ color: '#0275d8', cursor: 'pointer' }}>
                  <FormattedMessage {...messages.feedback_label} />
                </span>
              </div>
            )}
          />
          {value.modal === 'mahalla' && (
            <div style={{ color: '#808080' }} className="note mt-1">
              <span onClick={writeMahalla} style={{ color: '#0275d8', cursor: 'pointer' }}>
                <FormattedMessage {...messages.feedback_label} />
              </span>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Mahalla;



// WEBPACK FOOTER //
// ./src/application-form/field-components/mahalla.js